module.exports = __webpack_public_path__ + "media/images/communities/logos/ao3-87cf277167a2e609e77a31c9a63f79fb.png";